import { Clock } from 'lucide-react';
import { useStaffDashboard } from '../hooks';
import { DataView } from '../../../components/ui/DataView';
import { Card } from '../../../components/ui/Card';
import { Link } from '@tanstack/react-router';
import type { PeriodOption } from '@repo/shared-dashboard';

interface RecentActivityWidgetProps {
  period?: PeriodOption;
}

export function RecentActivityWidget({ period = 'month' }: RecentActivityWidgetProps) {
  const query = useStaffDashboard(period);

  return (
    <Card className="p-5 flex flex-col justify-between h-full">
      <div className="flex items-center justify-between border-b border-border pb-3 mb-4">
        <h3 className="text-sm font-semibold text-text-primary">Recent Activity</h3>
        <Link to="/audit" className="text-xs text-accent-500 font-semibold cursor-pointer hover:underline">
          View All
        </Link>
      </div>
      <DataView query={query} isEmpty={() => false}>
        {(data) => {
          const activities = data?.recentActivity ?? [];
          if (activities.length === 0) {
            return (
              <div className="py-8 flex flex-col items-center justify-center text-center my-auto">
                <div className="w-10 h-10 rounded-full bg-surface-2 flex items-center justify-center text-text-muted mb-2.5">
                  <Clock className="w-5 h-5 opacity-70" />
                </div>
                <p className="text-sm font-semibold text-text-primary">No Recent Activity</p>
                <p className="text-xs text-text-muted mt-1 max-w-[240px]">Audit logs and system transactions will populate here automatically</p>
              </div>
            );
          }

          return (
            <div>
              <div className="relative border-l border-border ml-2 pl-4 space-y-6">
                {activities.map((log) => (
                  <div key={log.id} className="relative">
                    <div
                      className={`absolute -left-[21px] top-1 w-2.5 h-2.5 rounded-full border border-surface-1 ${
                        log.type === 'success'
                          ? 'bg-success-500'
                          : log.type === 'info'
                            ? 'bg-info-500'
                            : log.type === 'warning'
                              ? 'bg-warning-500'
                              : log.type === 'danger'
                                ? 'bg-danger-500'
                                : 'bg-surface-3'
                      }`}
                    />
                    <p className="text-xs font-semibold text-text-muted">{log.date}</p>
                    <p className="text-sm text-text-primary mt-1">{log.description}</p>
                  </div>
                ))}
              </div>
            </div>
          );
        }}
      </DataView>
    </Card>
  );
}

